import React from 'react';
import { Box, Button, Typography } from '@mui/material';

interface ErrorPageProps {
  onRetry: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ onRetry }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    minHeight="100vh"
    px={2}
    textAlign="center"
  >
    <Typography variant="h4" gutterBottom>
      Ошибка загрузки
    </Typography>
    <Typography variant="body1" color="text.secondary">
      Сервер авторизации не запущен или не найден
    </Typography>
    <Button onClick={onRetry} variant="contained" color="primary" sx={{ mt: 3 }}>
      Повторить
    </Button>
  </Box>
);

export default ErrorPage;